import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import history from './History';
import './Footer.css';


class Footer extends Component {
  render() {
    return (
      <Navbar className="footer-navbar" bg="dark" variant="dark" expand="lg">
        <div className="copyright text-center" >
          ©{(new Date().getFullYear())}, Megadigm<span className="trademark">&reg;</span>. All rights reserved
        </div>
        <Navbar.Toggle aria-controls="footer-links"/>
        <Navbar.Collapse id="footer-links" className="justify-content-end">
          <Nav>
            <Nav.Link href="/privacypolicy">Privacy Policy</Nav.Link>
            <Nav.Link href="/termsandconditions">Terms & Conditions</Nav.Link>
            {/* <Nav.Link href="/requestform/generalinquiry">Contact Us</Nav.Link> */}
            <Nav.Link as={Link} to={{ pathname: '/requestform/generalinquiry', state: { from: history.location.pathname } }}>
              Contact Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Footer;